import { Flex } from 'antd';
import React, { useState } from 'react';

import styled from '@emotion/styled';

import { PrimaryBlackButton } from '../../../components/Button/Buttons';
import { Modal } from '../../../components/Modal/Modal';
import PaymentDetailsModal from '../../../components/Modal/ModalActions/PaymentDetailsModal';
import ScheduleDeliveryModal from '../../../components/Modal/ModalActions/ScheduleDeliveryModal';
import TrackPackagePaymentModal from '../../../components/Modal/ModalActions/TrackPackagePaymentModal';
import { ITrackPackageResponse } from '../../../models/trackPage/trackPackage.model';
import ViewPaymentDetailsButton from './ViewPaymentDetailsButton';

interface IProcessPackage {
  trackingInfo?: ITrackPackageResponse;
}

const pkgDescriptionMsg = (status: string) => {
  switch (status) {
    case 'PENDING':
      return 'Your parcel has arrived Nigeria and is currently undergoing Customs clearance';
    case 'CLEARED':
      return 'Your parcel has been cleared by Customs';
    case 'IN_WAREHOUSE':
      return 'Your parcel  is now at one of our secure warehouses and will be on its way to you soon';
    case 'OUT_FOR_DELIVERY':
      return 'Your parcel is now ready for delivery. Ensure you have your 6 digit OTP ready to confirm delivery upon dispatcher arrival.';
    case 'DELIVERED':
      return 'Your parcel has been successfully delivered to your preferred location';
  }
};

const ProcessPackage: React.FC<IProcessPackage> = ({ trackingInfo }) => {
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);

  return (
    <Container>
      <Label>
        This item's last mile delivery is handled by Confidence Mason Limited
      </Label>
      <BorderBox>
        <InlineBox className='spaceBtw'>
          <Description>
            {pkgDescriptionMsg(
              trackingInfo?.shippingStatus ?? 'PROCESSING_CLEARANCE',
            )}
          </Description>
        </InlineBox>

        {trackingInfo?.shippingStatus !== 'PENDING' && <Divider></Divider>}

        <InlineBox>
          {trackingInfo?.paid &&
            trackingInfo?.shippingStatus !== 'DELIVERED' &&
            trackingInfo?.shippingStatus !== 'OUT_FOR_DELIVERY' &&
            trackingInfo?.shippingStatus !== 'PENDING' && (
              <>
                <Flex
                  align='start'
                  justify='space-between'
                  style={{ width: '100%' }}
                >
                  <Flex vertical gap={16}>
                    <TextBar>Scheduled Delivery Date</TextBar>
                    <InlineBox>
                      <BolderTextBar>
                        {trackingInfo?.scheduledDeliveryDate}
                      </BolderTextBar>
                    </InlineBox>
                  </Flex>
                  <PrimaryBlackButton
                    onClick={() => setShowScheduleModal(true)}
                  >
                    Reschedule Delivery
                  </PrimaryBlackButton>
                </Flex>
                <Modal
                  showModal={showScheduleModal}
                  setShowModal={setShowScheduleModal}
                >
                  <ScheduleDeliveryModal data={trackingInfo} />
                </Modal>
              </>
            )}

          {!trackingInfo?.paid &&
            trackingInfo?.shippingStatus !== 'DELIVERED' &&
            trackingInfo?.shippingStatus !== 'OUT_FOR_DELIVERY' &&
            trackingInfo?.shippingStatus !== 'PENDING' && (
              <Flex
                align='start'
                justify='space-between'
                style={{ width: '100%' }}
              >
                <Flex vertical gap={16}>
                  <BolderTextBar>Payment confirms delivery date</BolderTextBar>
                  <InlineBox>
                    <ViewPaymentDetailsButton
                      onClick={() => setShowPaymentDetailsModal(true)}
                    />
                    <Modal
                      showModal={showPaymentDetailsModal}
                      setShowModal={setShowPaymentDetailsModal}
                    >
                      <PaymentDetailsModal trackingInfo={trackingInfo} />
                    </Modal>
                  </InlineBox>
                </Flex>
                <PrimaryBlackButton onClick={() => setShowPaymentModal(true)}>
                  Make Payment
                </PrimaryBlackButton>
                <Modal
                  showModal={showPaymentModal}
                  setShowModal={setShowPaymentModal}
                >
                  <TrackPackagePaymentModal />
                </Modal>
              </Flex>
            )}

          {trackingInfo?.shippingStatus === 'DELIVERED' && (
            <Flex vertical gap={16}>
              <TextBar>Delivery Date</TextBar>
              <InlineBox>
                <BolderTextBar>
                  {trackingInfo?.scheduledDeliveryDate}
                </BolderTextBar>
              </InlineBox>
            </Flex>
          )}
        </InlineBox>
      </BorderBox>
    </Container>
  );
};

export default ProcessPackage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Label = styled.div`
  font-weight: 600;
  font-style: SemiBold;
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0%;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const BorderBox = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 24px;
  border-radius: 10px;
`;

const InlineBox = styled.div`
  display: flex;

  align-items: center;
  gap: 1rem;

  &.spaceBtw {
    display: grid;
    grid-template-columns: 650px auto;
    justify-content: space-between;

    & > button {
      width: 220px;
    }
  }

  @media (max-width: 884px) {
    flex-direction: column;
    align-items: flex-start;

    &.spaceBtw {
      display: flex;
      grid-template-columns: 650px auto;
      justify-content: space-between;

      & > button {
        width: 220px;
      }
    }
  }
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #d9d9d9;
  margin: 22px 0;
`;

const Description = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

const TextBar = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
`;

const BolderTextBar = styled.div`
  font-size: 20px;
  font-weight: 600;
`;
